import type { ThemeComponents } from "./theme-components.type";

import {
  colorText,
  colorBodyBg,
  colorAccent,
  colorPrimary,
  colorBlack,
} from "../theme-colors";
import { THEME_Z_INDEX } from "../theme-z-index";

export const THEME_COMPONENTS: ThemeComponents = {
  Avatar: {
    // `default` size
    containerSize: 32,
    textFontSize: 14,
    // `small` size
    containerSizeSM: 24,
    textFontSizeSM: 10,
    // `large` size
    containerSizeLG: 40,
    textFontSizeLG: 16,
  },
  Button: {
    borderRadius: 1,
    colorTextDisabled: "#b8b8b8",
    colorBgContainerDisabled: "#f5f5f5",
    contentFontSizeSM: 13,
  },
  Breadcrumb: {
    itemColor: "#808080", // color applied to icon
    lastItemColor: "#808080", // color applied to icon
    linkColor: colorPrimary,
    linkHoverColor: colorAccent,
    separatorColor: colorText,
  },
  Card: {
    colorTextHeading: colorText,
    fontWeightStrong: 500,
  },
  DatePicker: {
    zIndexPopup: THEME_Z_INDEX.popup,
  },
  Drawer: {
    fontWeightStrong: 500,
  },
  Dropdown: {
    zIndexPopup: THEME_Z_INDEX.popup,
  },
  Form: {
    verticalLabelPadding: "0 0 2px",
  },
  Layout: {
    bodyBg: colorBodyBg,
    footerBg: colorBodyBg,
    headerBg: "#fff",
    headerHeight: 48,
  },
  Menu: {
    itemMarginInline: 0,
    itemSelectedBg: "#f3f3f4",
  },
  Notification: {
    borderRadiusLG: 8,
    borderRadiusSM: 8,
  },
  Popover: {
    zIndexPopup: THEME_Z_INDEX.popup,
  },
  Select: {
    zIndexPopup: THEME_Z_INDEX.popup,
  },
  Splitter: {
    splitBarDraggableSize: 60,
  },
  Table: {
    rowSelectedBg: "#f3f3f4",
    rowSelectedHoverBg: "#ededed",
    fontWeightStrong: 500,
  },
  Tabs: {
    cardBg: "#fafafa",
    itemHoverColor: colorAccent,
    itemSelectedColor: colorBlack,
    inkBarColor: colorBlack,
  },
  Timeline: {
    dotBg: "#fff",
    dotSize: 16,
    tailWidth: 3,
  },
  Tooltip: {
    colorBgSpotlight: "#898989",
    zIndexPopup: THEME_Z_INDEX.popup,
  },
  Tree: {
    controlHeight: 30,
    controlHeightSM: 22,
    nodeSelectedBg: "#f3f3f4",
  },
  Typography: {
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 18,
    fontSizeHeading4: 14,
    fontSizeHeading5: 14,
  },
};
